export default "__VITE_ASSET__BfkX2Kis__"